var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { plainToInstance } from 'class-transformer';
import dayjs from 'dayjs';
import Clinic from './Clinic';
import ClinicRoom from './ClinicRoom';
import DoctorScheduleConfig from './DoctorScheduleConfig';
import Doctor from './Doctor';
import Model from 'models/Model';
var DoctorSchedule = /** @class */ (function (_super) {
    __extends(DoctorSchedule, _super);
    function DoctorSchedule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clinic_room_id = null;
        _this.day_of_week = 0;
        return _this;
    }
    DoctorSchedule.prototype.getId = function () {
        return Number(this.id);
    };
    DoctorSchedule.prototype.getDoctorId = function () {
        var _a, _b;
        var value = Number((_a = this.doctor_id) !== null && _a !== void 0 ? _a : (_b = this.doctor) === null || _b === void 0 ? void 0 : _b.id);
        return Number.isNaN(value) ? 0 : value;
    };
    DoctorSchedule.prototype.setDoctorId = function (value) {
        this.doctor_id = Number(value);
    };
    DoctorSchedule.prototype.getClinicId = function () {
        var _a, _b;
        var value = Number((_a = this.clinic_id) !== null && _a !== void 0 ? _a : (_b = this.clinic) === null || _b === void 0 ? void 0 : _b.id);
        return Number.isNaN(value) ? 0 : value;
    };
    DoctorSchedule.prototype.setClinicId = function (value) {
        this.clinic_id = Number(value);
    };
    DoctorSchedule.prototype.getClinicRoomId = function () {
        var _a, _b;
        var value = (_a = this.clinic_room_id) !== null && _a !== void 0 ? _a : (_b = this.clinic_room) === null || _b === void 0 ? void 0 : _b.id;
        var numeric = Number(value);
        if (value == null || Number.isNaN(numeric) || numeric <= 0) {
            return null;
        }
        return numeric;
    };
    DoctorSchedule.prototype.setClinicRoomId = function (value) {
        var _a;
        this.clinic_room_id = value == null ? null : Number(value);
        if (((_a = this.clinic_room) === null || _a === void 0 ? void 0 : _a.id) !== this.clinic_room_id) {
            this.clinic_room = undefined;
        }
    };
    DoctorSchedule.prototype.getClinicRoom = function () {
        if (this.clinic_room == null) {
            return undefined;
        }
        return plainToInstance(ClinicRoom, this.clinic_room);
    };
    DoctorSchedule.prototype.getDayOfWeek = function () {
        var value = Number(this.day_of_week);
        return Number.isNaN(value) ? 0 : value;
    };
    DoctorSchedule.prototype.setDayOfWeek = function (value) {
        this.day_of_week = Number(value);
    };
    DoctorSchedule.prototype.getDayName = function () {
        var _a;
        if (this.day_name) {
            return this.day_name;
        }
        var names = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return (_a = names[this.getDayOfWeek()]) !== null && _a !== void 0 ? _a : '';
    };
    DoctorSchedule.prototype.getShiftName = function () {
        return this.shift_name;
    };
    DoctorSchedule.prototype.setShiftName = function (value) {
        this.shift_name = value;
    };
    DoctorSchedule.prototype.getStartTime = function () {
        return this.start_time;
    };
    DoctorSchedule.prototype.setStartTime = function (value) {
        this.start_time = value;
    };
    DoctorSchedule.prototype.getFormattedStartTime = function () {
        return this.formatScheduleTime(this.getStartTime());
    };
    DoctorSchedule.prototype.getStartTimeAsDayjs = function () {
        return this.parseScheduleTime(this.getStartTime());
    };
    DoctorSchedule.prototype.getEndTime = function () {
        return this.end_time;
    };
    DoctorSchedule.prototype.setEndTime = function (value) {
        this.end_time = value;
    };
    DoctorSchedule.prototype.getFormattedEndTime = function () {
        return this.formatScheduleTime(this.getEndTime());
    };
    DoctorSchedule.prototype.getEndTimeAsDayjs = function () {
        return this.parseScheduleTime(this.getEndTime());
    };
    DoctorSchedule.prototype.isActive = function () {
        return this.active;
    };
    DoctorSchedule.prototype.setActive = function (value) {
        this.active = value;
    };
    DoctorSchedule.prototype.getConfig = function () {
        var config = plainToInstance(DoctorScheduleConfig, this.config || {});
        if (config.max_appointments == null) {
            config.setMaxAppointments(0);
        }
        if (config.max_online_appointments == null) {
            config.setMaxOnlineAppointments(0);
        }
        if (config.online_appointment_enabled == null) {
            config.setOnlineAppointmentEnabled(true);
        }
        this.config = config;
        return config;
    };
    DoctorSchedule.prototype.setConfig = function (config) {
        var normalized = new DoctorScheduleConfig();
        normalized.setMaxAppointments(config.getMaxAppointments());
        normalized.setMaxOnlineAppointments(config.getMaxOnlineAppointments());
        normalized.setOnlineAppointmentEnabled(config.isOnlineAppointmentEnabled());
        this.config = normalized;
    };
    DoctorSchedule.prototype.getMaxAppointments = function () {
        return this.getConfig().getMaxAppointments();
    };
    DoctorSchedule.prototype.getMaxOnlineAppointments = function () {
        return this.getConfig().getMaxOnlineAppointments();
    };
    DoctorSchedule.prototype.isOnlineAppointmentEnabled = function () {
        return this.getConfig().isOnlineAppointmentEnabled();
    };
    DoctorSchedule.prototype.getDoctor = function () {
        if (this.doctor == null) {
            return undefined;
        }
        return plainToInstance(Doctor, this.doctor);
    };
    DoctorSchedule.prototype.getClinic = function () {
        if (this.clinic == null) {
            return undefined;
        }
        return plainToInstance(Clinic, this.clinic);
    };
    DoctorSchedule.prototype.toRequestBody = function (mode) {
        var config = this.getConfig();
        var body = {
            day_of_week: this.getDayOfWeek(),
            shift_name: this.getShiftName(),
            start_time: this.clockForApi(this.getStartTime()),
            end_time: this.clockForApi(this.getEndTime()),
            active: this.isActive(),
            clinic_room_id: this.getClinicRoomId(),
            config: {
                max_appointments: config.getMaxAppointments(),
                max_online_appointments: config.getMaxOnlineAppointments(),
                online_appointment_enabled: config.isOnlineAppointmentEnabled()
            }
        };
        if (mode === 'create') {
            body.doctor_id = this.getDoctorId();
            body.clinic_id = this.getClinicId();
        }
        return body;
    };
    DoctorSchedule.prototype.clockForApi = function (value) {
        var parsed = this.parseScheduleTime(value);
        return parsed ? parsed.format('HH:mm:ss') : value;
    };
    DoctorSchedule.prototype.formatScheduleTime = function (value) {
        var raw = value === null || value === void 0 ? void 0 : value.trim();
        if (!raw) {
            return '—';
        }
        var hasOnlyTime = /^\d{2}:\d{2}(:\d{2})?$/.test(raw);
        var normalized = hasOnlyTime
            ? "2000-01-01T".concat(raw.length === 5 ? "".concat(raw, ":00") : raw)
            : raw;
        var parsed = dayjs(normalized);
        return parsed.isValid() ? parsed.format('hh:mm A') : raw;
    };
    DoctorSchedule.prototype.parseScheduleTime = function (value) {
        var _a;
        if (!value) {
            return undefined;
        }
        var raw = value.trim();
        if (!raw) {
            return undefined;
        }
        var hms = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/.exec(raw);
        if (hms) {
            var hour = Number(hms[1]);
            var minute = Number(hms[2]);
            var second = Number((_a = hms[3]) !== null && _a !== void 0 ? _a : 0);
            return dayjs().hour(hour).minute(minute).second(second).millisecond(0);
        }
        var ampm = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i.exec(raw);
        if (ampm) {
            var hour = Number(ampm[1]);
            var minute = Number(ampm[2]);
            var period = ampm[3].toUpperCase();
            if (period === 'PM' && hour < 12) {
                hour += 12;
            }
            if (period === 'AM' && hour === 12) {
                hour = 0;
            }
            return dayjs().hour(hour).minute(minute).second(0).millisecond(0);
        }
        var parsed = dayjs(raw);
        return parsed.isValid() ? parsed : undefined;
    };
    return DoctorSchedule;
}(Model));
export default DoctorSchedule;
